import { createSelector } from 'reselect';

import { RootState } from 'types/store';

export const selectSession = (state: RootState) => state.session;

const selectMainSessionId = createSelector(selectSession, (session) => session.mainSessionId);

export { selectMainSessionId };
